<template>
  <transition name="expand">
    <div
      ref="container"
      class="tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl tw-mb-4"
      :style="{
        height: expanded ? `${contentHeight}px` : `${familyHeadHeight}px`,
        transition: `height ${(foreigner.family_profiles?.length ?? 1) * .045}s ease-out`
      }"
    >
      <ForeignersListItem
        ref="familyHead"
        :foreigner="foreigner"
        :expanded="expanded"
        @toggleExpanded="toggleExpanded"
      />
      <transition
        name="expand"
        @enter="startExpandTransition"
        @after-enter="endExpandTransition"
      >
        <div
          v-if="expanded"
          ref="content"
        >
          <template
            v-for="member in foreigner.family_profiles"
            :key="member.id"
          >
            <div
              class="tw-w-full tw-ml-6 tw-h-px tw-bg-gray dark:tw-bg-dm-gray"
            />
            <ForeignersListItem
              :foreigner="member"
            />
          </template>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
import ForeignersListItem from '@/components/Foreigners/List/ForeignersListItem.vue';

export default {
  name: 'ForeignerFamilyHead',
  components: { ForeignersListItem },
  props: {
    foreigner: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
      contentHeight: 0,
    };
  },
  computed: {
    familyHeadHeight() {
      return 96;
    },
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;

      // get height after next tick
      this.$nextTick(() => {
        if (this.expanded) {
          this.contentHeight = this.$refs.content.scrollHeight;
        } else {
          this.contentHeight = this.familyHeadHeight;
        }
      });
    },
    startExpandTransition() {
      this.$nextTick(() => {
        this.contentHeight = this.$refs.content.scrollHeight + this.familyHeadHeight;
      });
    },
    endExpandTransition() {
      this.contentHeight = 'auto';
    },
  },
};
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
  transition: height 0.3s ease;
}
</style>
